export default "__VITE_ASSET__a68ec810__"